<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ $t("tours_models.tours_models") }}</h1>
                    </v-col>
                </v-row>
                <v-btn
                    color="secondary"
                    class="btn-add floating-btn"
                    elevation="0"
                    @click="$router.push({ name: 'tours_models_new' })"
                >
                    <v-icon size="18">mdi-plus</v-icon>
                    {{ $t("global.add") }}
                </v-btn>
            </div>

            <div class="wrap-datables">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :custom-filter="customFilter"
                            :custom-sort="customSort"
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="tour_models"
                            :items-per-page="25"
                            :search="search"
                            :sort-by="'model_number_site'"
                        >

                            <template #[`item.model_number_code`]="{ item }">
                                {{ item.model_number.code }}
                            </template>
                            <template #[`item.model_number_site`]="{ item }">
                                {{ item.model_number.site.label }}
                                ({{ item.model_number.site.code }})
                            </template>

                            <template #[`item.tour_type`]="{ item }">
                                {{ item.tour_type.designation }}
                            </template>

                            <template #[`item.driver`]="{ item }">
                                {{ item.driver.firstname }}
                                {{ item.driver.lastname }}
                            </template>

                            <template #[`item.actions`]="{ item }">
                                <v-btn
                                    class="see ma-1"
                                    icon
                                    small
                                    dark
                                    @click="
                                        $router.push({
                                            name: 'tours_models_edit',
                                            params: { id: item.id },
                                        })
                                    "
                                >
                                    <v-icon size="16">mdi-eye</v-icon>
                                </v-btn>
                            </template>

                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-col>
</template>

<script>
export default {
    name: "ToursModels",
    data() {
        return {
            tour_models: [],
            search: "",
            headers: [
                {
                    text: this.$t("tours_models.start_site"),
                    align: "start",
                    sortable: true,
                    value: "model_number_site",
                },
                {
                    text: this.$t("tours_models.model_code"),
                    align: "center",
                    sortable: true,
                    value: "model_number_code",
                },
                {
                    text: this.$t("tours_models.type"),
                    align: "start",
                    sortable: true,
                    value: "tour_type",
                },
                {
                    text: this.$tc("tours_models.drivers", 1),
                    align: "start",
                    sortable: true,
                    value: "driver",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
        };
    },
    async mounted() {
        await this.$api.tour_models.all({
            params: {
                includes: 'tour_model.driver,tour_model.model_number,model_number.site,tour_model.tour_type'
            }
        }).then(({data: tour_models}) => this.tour_models = tour_models.data)
    },
    methods: {
        customFilter(value, search, item) {
            search = search.toLowerCase()
            return (
                item.model_number.code.toLowerCase().includes(search) ||
                item.model_number.site.label.toLowerCase().includes(search) ||
                item.model_number.site.code.toLowerCase().includes(search) ||
                item.tour_type.designation.toLowerCase().includes(search) ||
                item.driver.lastname.toLowerCase().includes(search) ||
                item.driver.firstname.toLowerCase().includes(search)
            )
        },
        customSort(items, index, isDescending) {
            items.sort((a, b) => {
                if (index[0] === 'model_number_site') {
                    if (isDescending[0]) {
                        return b.model_number.site.label.localeCompare(a.model_number.site.label);
                    } else {
                        return a.model_number.site.label.localeCompare(b.model_number.site.label);
                    }
                }

                if (index[0] === 'model_number_code') {
                    if (isDescending[0]) {
                        return b.model_number.code.localeCompare(a.model_number.code);
                    } else {
                        return a.model_number.code.localeCompare(b.model_number.code);
                    }
                }

                if (index[0] === 'tour_type') {
                    if (isDescending[0]) {
                        return b.tour_type.designation.localeCompare(a.tour_type.designation);
                    } else {
                        return a.tour_type.designation.localeCompare(b.tour_type.designation);
                    }
                }

                if (index[0] === 'driver') {
                    if (isDescending[0]) {
                        return b.driver.firstname.localeCompare(a.driver.firstname);
                    } else {
                        return a.driver.firstname.localeCompare(b.driver.firstname);
                    }
                }
            });

            return items;
        }
    },
};
</script>
